export const INTERVAL_SESSION_MODAL = 10 * 1000;
